/**
 * App-version constants baked into the bundle at build time. The build
 * script `scripts/writeVersionFile.js` writes public/version.json with
 * the same package version + a unique buildId. The UpdatePrompt
 * component polls the JSON and compares against these constants to
 * decide whether a new deploy is available.
 */

import pkg from '../package.json';

/** Semver version from package.json, e.g. "1.5.0". */
export const APP_VERSION: string = pkg.version;

/** Bundled at build time — replaced by Next.js define plugin. */
export const APP_BUILD_ID: string =
  typeof process !== 'undefined' && process.env.NEXT_PUBLIC_BUILD_ID
    ? process.env.NEXT_PUBLIC_BUILD_ID
    : pkg.version;

/**
 * PRESCRIPTION ENGINE VERSION — stamped onto every saved session.
 *
 * Separate from APP_VERSION on purpose. The load-selection chain can change
 * inside a patch release, and when slicing telemetry ("did the fix help?")
 * the engine is the axis that matters. Bump this whenever the behaviour of
 * the prescription chain changes — smartWorkoutGenerator,
 * statisticalRecommendation, adaptiveCardioPace, the deload triggers.
 *
 * Held at 2 for the whole 2026-08 remediation:
 *   - VDOT eligibility ordering + cardio modality gating
 *   - cardio history pooled by modality, distance anchored per exercise
 *   - robust load anchor (outlier rejection, not a median)
 *   - prep/cool-down excluded from the fatigue signal and the deload streak
 *   - authored effort targets surviving generation (they were discarded)
 *   - block format no longer overrides an exercise's tracking type
 *   - overallFatigue computed from working sets only
 *
 * Deliberately NOT bumped to 3 for the later fixes in this batch. Version 2
 * has never reached production — the deployed 1.9.80 build predates the stamp
 * existing at all — so every one of these changes is in the first build that
 * will ever emit an engineVersion. Rolling to 3 now would create a version
 * with zero records and split the cohort for no reason.
 *
 * Sessions stamped 1 do not exist; nothing was stamped before 2026-08-15.
 */
export const ENGINE_VERSION = 2;
